<app-menu></app-menu>
<!-- <app-global-search-grid></app-global-search-grid> -->
<div class="relative w-full h-auto us:mt-163px us-landscape:mt-117px md:mt-117px lg-landscape:mt-114px">
    <router-outlet></router-outlet>
</div>
<app-chat-button></app-chat-button>
<app-footer class=""></app-footer>
